import { defineComponent as _defineComponent } from 'vue'
import { Trade, getCurrencyPair, getPrimaryCcy } from 'ah-api-gateways';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeFxRateCell',
  props: {
    item: null,
    showCurrencyPair: { type: [Boolean, String], default: false }
  },
  setup(__props: any) {

const props = __props as { item: Trade, showCurrencyPair: boolean | string };



const tradeCurrencyPair = computed(() => getCurrencyPair(props.item));

const getProductRate = computed(() => getPrimaryCcy(props.item).clientRate);

return { __sfc: true,props, tradeCurrencyPair, getProductRate }
}

})